import Users from 'Portal/components/Users/Users'
import User from 'Portal/components/Users/User'

// Routes
export default [
    {
        path: 'users',
        name: 'users',
        component: Users
    },
    {
        path: 'users/:id',
        name: 'user',
        component: User
    }
]
